import { ChevronDown } from "@asphalt-react/iconpack";
import { observer } from "mobx-react-lite";
import React, { createRef, useEffect } from "react";
import { KNOWN_LANGUAGES, LanguageCode } from "src/stores";
import styled from "styled-components";
import { Box } from "../Box";
import { Text } from "../Text";
import Popover, { close, toggle } from "@asphalt-react/popover";
import { MediaQueries } from "src/constants";
import { useAnalytics, useTranslation } from "src/hooks";
import { useLanguageSwitcherState } from "./LanguageSwitcher.state";
import { useRootStore } from "src/stores/Root.store";

const ButtonEl = styled.div`
  :hover {
    cursor: pointer;
  }
  padding-right: ${(p) => p.theme.dimension.spacing.l}px;
  ${MediaQueries.screen.medium.maxWidth} {
    padding-right: ${(p) => p.theme.dimension.spacing.s}px;
  }
`;

const PopoverEl = styled.div<{ isSelected?: boolean }>`
  width: ${(p) => p.theme.dimension.width.languageSwitcherPopover}px;
  background-color: ${(p) => p.theme.colors.background.white};
  padding: ${(p) => p.theme.dimension.spacing.s}px 18px;
  :hover {
    cursor: pointer;
  }

  ${(p) =>
    p.isSelected &&
    `background-color:rgb(242,244,247);
    `}
`;

const PopoverContainerEl = styled.div`
  ${MediaQueries.screen.medium.maxWidth} {
    margin-top: -${(p) => p.theme.dimension.spacing.l}px;
  }
`;

type LanguageSwitcherProps = {
  defaultLanguage?: string;
};

/* TODO: sendy.suryana 01/25/2021 17:36 GMT+7
 * Delete src/components/Header/Header.LanguageSwitcher.component.tsx
 */
export const LanguageSwitcher = observer((props: LanguageSwitcherProps) => {
  const {
    $translationStore: { switchLanguage, language$ },
  } = useRootStore();
  const innerRef = createRef();
  const translate = useTranslation(require("./translations.json"));
  const { defaultLanguage } = props;
  const { getPopoverPlacement } = useLanguageSwitcherState();
  // Use older analytics because the component is reusable between passport and dashboard
  const { sendEvent, prefix } = useAnalytics();

  useEffect(() => {
    defaultLanguage && switchLanguage(defaultLanguage! as LanguageCode);
  }, [defaultLanguage, switchLanguage]);

  const _switchLanguage = (language: LanguageCode) => {
    close(innerRef);
    switchLanguage(language);
    sendEvent(`${prefix}LanguageSwitcher_${language}`);
  };

  return (
    <>
      <Popover
        placement={getPopoverPlacement()}
        target={
          <ButtonEl onClick={() => toggle(innerRef)}>
            <Box flex>
              <Text fontSize="medium" fontWeight="demi" marginRightXs>
                {language$.toUpperCase()}
              </Text>
              <ChevronDown />
            </Box>
          </ButtonEl>
        }
        ref={innerRef}
      >
        <PopoverContainerEl>
          {KNOWN_LANGUAGES.map((language) => (
            <PopoverEl
              key={language}
              isSelected={language$ === language}
              onClick={() => {
                _switchLanguage(language as LanguageCode);
              }}
            >
              {translate(language)}
            </PopoverEl>
          ))}
        </PopoverContainerEl>
      </Popover>
    </>
  );
});
